(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ps-testimonials')) {
    customElements.define(
      'ps-testimonials',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.slides = Array.from(this.track.children);
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.index = -1;

          this.onScroll = () => {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.update();
            });
          };
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

          // Desktop shows three cards: start on the second so the raised card has a neighbour on both sides.
          const start = this.slides.length > 2 && window.matchMedia('(min-width: 750px)').matches ? 1 : 0;
          requestAnimationFrame(() => {
            this.go(start, 'instant');
            this.update();
          });

          const seconds = Number(this.dataset.autoplay);
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (seconds > 0 && !reduced && this.slides.length > 1) {
            this.paused = false;
            const pause = () => (this.paused = true);
            const resume = () => (this.paused = false);
            this.addEventListener('mouseenter', pause);
            this.addEventListener('mouseleave', resume);
            this.addEventListener('touchstart', pause, { passive: true });
            this.timer = setInterval(() => {
              if (!this.paused) this.go((this.index + 1) % this.slides.length);
            }, seconds * 1000);
          }
        }

        disconnectedCallback() {
          clearInterval(this.timer);
          if (this.frame) cancelAnimationFrame(this.frame);
        }

        go(i, behavior = 'smooth') {
          const slide = this.slides[i];
          if (!slide) return;
          const left = slide.offsetLeft - (this.track.clientWidth - slide.offsetWidth) / 2;
          this.track.scrollTo({ left, behavior });
        }

        update() {
          const center = this.track.scrollLeft + this.track.clientWidth / 2;
          let best = 0;
          let bestDistance = Infinity;
          this.slides.forEach((slide, i) => {
            const distance = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center);
            if (distance < bestDistance) {
              bestDistance = distance;
              best = i;
            }
          });
          if (best === this.index) return;
          this.index = best;
          this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === best));
          this.dots.forEach((dot, i) => dot.toggleAttribute('aria-current', i === best));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
